import { render } from "./RetroShip.vue?vue&type=template&id=5ad97874&scoped=true"
import script from "./RetroShip.vue?vue&type=script&lang=js"
export * from "./RetroShip.vue?vue&type=script&lang=js"

import "./RetroShip.vue?vue&type=style&index=0&id=5ad97874&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad97874"]])

export default __exports__